export enum QueryKey {
  Sign = 'sign',
  Partner = 'partner',
  Profile = 'profile',
  Follow = 'follow',
  Block = 'block',
  Report = 'report',
  User = 'user',
  UserMarketingAgreement = 'userMarketingAgreement',
  Viewer = 'viewer',
  Favorite = 'favorite',
  FavoriteCount = 'favoriteCount',
  Library = 'library',
  RecentlyRead = 'recentlyRead',
  EpisodeReadRecord = 'episodeReadRecord',
  EpisodeReadPosition = 'episodeReadPosition',
  Best = 'best',
  FancyShare = 'fancyShare',
  Rolling = 'rolling',
  Chat = 'chat',

  ActivityPoint = 'activityPoint',
  ActivityPointSeason = 'activityPointSeason',
  ActivityPointRank = 'activityPointRank',
  AttendanceCheck = 'attendanceCheck',
  AcitivitySummary = 'activitySummary',
  ActivityPastSeasons = 'ActivityPastSeasons',
  Content = 'content',
  Contest = 'contest',
  HomeSection = 'homeSection',
  Section = 'Section',
  Episode = 'episode',
  Recommend = 'recommend',
  Edit = 'edit',
  Relay = 'relay',
  Reply = 'reply',
  ReReply = 'reReply',
  ReplyLike = 'replyLike',
  ReplyCount = 'replyCount',
  ReplyReport = 'replyReport',
  ReplyPin = 'replyPin',
  ReplyUnpin = 'replyUnPin',
  Search = 'search',
  NotiNewEpisode = 'notiNewEpisode',
  InboxNoti = 'inboxNoti',
  DataAnalysis = 'dataAnalysis',
  InboxNotiUnreadCount = 'inboxNotiUnreadCount',
  Device = 'device',
  Event = 'event',
  EventParticipate = 'eventParticipate',
  Coupon = 'coupon',
  CouponCatalog = 'couponCatalog',
  Personal = 'personal',
  System = 'system',
  Promotion = 'promotion',
  PromotionItem = 'promotionItem',
  PromotionParticipate = 'promotionParticipate',
  PromotionReply = 'promotionReply',
  PromotionReplyLike = 'promotionReplyLike',

  WsContent = 'wsContent',
  WsEpisode = 'wsEpisode',
}
